import React from 'react';

export function UiSpacer() {
  return <div style={{ height: '15px' }} />;
}
